export var PersonalNameOrder;
(function (PersonalNameOrder) {
    PersonalNameOrder["WESTERN"] = "western";
    PersonalNameOrder["EASTERN"] = "eastern";
})(PersonalNameOrder || (PersonalNameOrder = {}));
